/** 静态资源 CDN 根地址：生产为 web.ettovr.com，开发留空走本地 devServer */
export const STATIC_BASE = process.env.STATIC_BASE || ''

/** 将 /static/... 转为可访问的完整 URL */
export function resolveStaticUrl (path) {
  if (!path || typeof path !== 'string') return path
  if (/^(https?:|data:|blob:)/i.test(path)) return path
  if (/^\//.test(path) && /^(https?:|data:|blob:)/i.test(path.replace(/^\//, ''))) {
    return path.replace(/^\//, '')
  }
  const rel = path.startsWith('/') ? path : `/${path}`
  const base = (STATIC_BASE || '').replace(/\/$/, '')
  return base ? `${base}${rel}` : rel
}



// WEBPACK FOOTER //
// ./src/config/staticAssets.js